/** Display legacy incident rows without changing their stored nullable labels. */
export const getIncidentTypeLabel = (
  incidentType: { id: string; label?: string | null } | null | undefined,
): string =>
  incidentType
    ? incidentType.label?.trim() || `Unnamed incident type (${incidentType.id})`
    : "Unclassified";

/** Browser-owned column IDs retained through the incident terminology cutover. */
export const INCIDENT_TYPE_COLUMN_ALIASES: Record<string, string> = {
  Type: "Incident Type",
  "Matter Type": "Incident Type",
  "Case Type": "Incident Type",
};

/** Migrate browser-owned filters; only canonical keys are sent to the API. */
export const migrateIncidentTypeFilters = <T extends Record<string, unknown>>(
  filters: T,
): T => {
  const legacySort =
    filters.sort === "type" ||
    (Array.isArray(filters.sort) && filters.sort.includes("type"));
  if (!("typeId" in filters) && !legacySort) return filters;
  const { typeId, ...canonical } = filters;
  return {
    ...canonical,
    ...("typeId" in filters
      ? { incidentTypeId: canonical.incidentTypeId ?? typeId }
      : {}),
    ...(legacySort
      ? {
          sort: Array.isArray(filters.sort)
            ? filters.sort.map((sort: unknown) =>
                sort === "type" ? "incidentType" : sort,
              )
            : "incidentType",
        }
      : {}),
  } as unknown as T;
};
